export default "__VITE_ASSET__908bfe18__"